type ShadowSettings = {
    type: "basic" | "percentage" | "soft" | "variance";
    mapSize?: number;
    radius?: number;
    blurSamples?: number;
};

type Settings = {
    shadows?: boolean | ShadowSettings;
    logDebugInfo?: boolean;
    showStats?: boolean;
    postprocessing?: boolean;
};

const DEFAULT_SHADOW_SETTINGS: Required<ShadowSettings> = {
    type: "soft",
    blurSamples: 2,
    radius: 0.2,
    mapSize: 4096,
};

const DEFAULT_SETTINGS: Settings = {
    shadows: DEFAULT_SHADOW_SETTINGS,
    logDebugInfo: false,
    showStats: false,
    postprocessing: false,
};

const loadSettingsFromLocalStorage = (): Settings => {
    const settings = localStorage.getItem("settings");
    if (!settings) {
        return DEFAULT_SETTINGS;
    }

    const loadedSettings = JSON.parse(settings);

    return {
        ...DEFAULT_SETTINGS,
        ...loadedSettings,
    };
};

export const SETTINGS = (() => loadSettingsFromLocalStorage())();

export const getShadowSettings = (settings: Settings): Required<ShadowSettings> | undefined => {
    if (typeof settings.shadows === "boolean") {
        return settings.shadows ? DEFAULT_SHADOW_SETTINGS : undefined;
    }

    return {
        ...DEFAULT_SHADOW_SETTINGS,
        ...settings.shadows,
    };
};

export const SHADOW_SETTINGS = getShadowSettings(SETTINGS);
